import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./login_lms.css";
import { sendForgotPassword } from "../../service/UserService";

export default function ForgotPassword() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: "" });
    const [formError, setFormError] = useState({ errorEmail: "" });
    const [showLoader, setShowLoader] = useState(false);
    const [message, setMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setFormError({ errorEmail: "" });
        setMessage("");
    };

    const handleFormClear = () => setFormData({ email: "" });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.email) {
            setFormError({ errorEmail: "Email is required." });
            return;
        }

        setShowLoader(true);
        setMessage("");

        try {
            const response = await sendForgotPassword({ email: formData.email });
            setIsSuccess(true);
            setMessage(response.message || "Reset link sent! Please check your email.");
            handleFormClear();
        } catch (error) {
            setIsSuccess(false);
            setMessage(error.message || "Failed to send reset link. Please try again.");
        } finally {
            setShowLoader(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <h1 className="login-title-lms">Forgot Password?</h1>
                <p className="login-subtitle-lms">Enter your email to get a reset link</p>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <div className="input-container">
                            <input
                                type="text"
                                name="email"
                                className={`form-input ${formError.errorEmail ? "error" : ""}`}
                                value={formData.email}
                                onChange={handleInputChange}
                                placeholder={formError.errorEmail ? formError.errorEmail : "Email"}
                            />
                        </div>
                    </div>
                    <button
                        type="submit"
                        className="login-button"
                        disabled={showLoader}
                        style={{ opacity: showLoader ? 0.6 : 1, cursor: showLoader ? "not-allowed" : "pointer" }}
                    >
                        {showLoader ? "Sending..." : "Send Link"}
                    </button>
                </form>

                {message && (
                    <div className="signup-link" style={{
                        color: isSuccess ? "green" : "red",
                        backgroundColor: isSuccess ? "#d4edda" : "#f8d7da",
                        padding: "10px",
                        borderRadius: "5px",
                        border: `1px solid ${isSuccess ? "#c3e6cb" : "#f5c6cb"}`,
                        marginTop: "15px",
                    }}>
                        {message}
                    </div>
                )}

                <div className="divider">Or</div>
                <div className="signup-link">
                    Remember your password? <a href="/login">Login</a>
                </div>
            </div>
        </div>
    );
}